import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientWholesalerEntity } from './client-wholesaler.entity';

/**
 * PD-17066 — a product group a customer buys from a competitor.
 *
 * A product group is the item's `category` text, the value the sales reports
 * group by ("Sales by Customer and Product Group"), not a row of the
 * `category` table: that table is empty for most tenants and holds unrelated
 * records on others (job codes on Macomb). So the group is stored by name.
 *
 * The parent link is HARD-deleted by SM1 and the legacy object API (it is in
 * database sync's hardDeleteTables), so the foreign key cascades: a removed
 * link takes its product groups with it instead of blocking SM1's delete.
 * SM2 hard-deletes these rows too, so the unique pair can be re-added.
 */
@Index(
	'client_wholesaler_category_uindex',
	['fkClientWholesalerId', 'category'],
	{ unique: true },
)
@Entity('client_wholesaler_category')
export class ClientWholesalerCategoryEntity extends BaseEntity {
	@Column('int', { name: 'fk_client_wholesaler__id', unsigned: true })
	public fkClientWholesalerId!: number;

	/** Matches `item.category` (varchar 64). */
	@Column('varchar', { name: 'category', length: 64 })
	public category!: string;

	@ManyToOne(
		() => ClientWholesalerEntity,
		(clientWholesaler) => clientWholesaler.categories,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([
		{ name: 'fk_client_wholesaler__id', referencedColumnName: 'id' },
	])
	public clientWholesaler!: ClientWholesalerEntity;
}
